import {
    FETCH_DEVICE_CONFIG,
    FETCH_DEVICE_CONFIG_SUCCESS,
    FETCH_DEVICE_CONFIG_FAILURE,
    UPDATE_DEVICE_CONFIG,
    UPDATE_DEVICE_CONFIG_SUCCESS,
    UPDATE_DEVICE_CONFIG_FAILURE,
  } from 'constants/ActionTypes';
  
  const initial_state = {
    data: [],
    fetching: false,
    error: null,
  };
  
  const device_config_reducer = (state = initial_state, action) => {
    switch (action.type) {
      case FETCH_DEVICE_CONFIG:
        return {
          ...state,
          fetching: true,
        };
      case FETCH_DEVICE_CONFIG_FAILURE:
        return {
          ...state,
          fetching: false,
          error: action.error,
        };
      case FETCH_DEVICE_CONFIG_SUCCESS:
        return {
          ...state,
          fetching: false,
          data: action.payload,
        };
      case UPDATE_DEVICE_CONFIG:
        return {
          ...state,
          fetching: true,
        };
      case UPDATE_DEVICE_CONFIG_SUCCESS:
        return {
          ...state,
          fetching: false,
        };
      case UPDATE_DEVICE_CONFIG_FAILURE:
        return {
          ...state,
          fetching: false,
          error: action.error,
        };
      default:
        return state;
    }
  };
  
  export default device_config_reducer;
  